import { createInertiaQueryClient } from './createInertiaQueryClient'

/**
 * The app's shared Vue Query client. A singleton so feature composables and the
 * RBAC transport (which runs outside component setup) read and write the same
 * cache.
 */
export const queryClient = createInertiaQueryClient()
